/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-08 16:29:43
 * @LastEditors: 刘行 liuhang@nextmar.com
 * @LastEditTime: 2025-05-21 16:32:11
 * @FilePath: /zeelool-nextjs/src/app/account/refer-a-friend/components/RuleItem.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';

import { QuestionFilled } from '@zeelool/icon';
import { useTranslations } from 'next-intl';
import { useCallback } from 'react';
import { useInviteFriendStore } from '../store/invite-friend-store';

const RuleItem = (props: { isAuthenticated: boolean }) => {
  const { isAuthenticated } = props;
  const t = useTranslations('account.referAFriend');
  const openRuleDialogWithType = useInviteFriendStore((state) => state.openRuleDialogWithType);

  // TODO:不知道为什么这里的INP指标不达标，达到200+ms
  return (
    <div
      className={`flex items-center lg:absolute cursor-pointer text-[#666] text-12 lg:hover:text-primary-purple ${
        isAuthenticated ? 'right-12 bottom-12' : 'right-[65px] bottom-[16px]'
      }`}
      onClick={useCallback(() => {
        openRuleDialogWithType('rules');
      }, [])}
    >
      <QuestionFilled className="mr-4 text-[12px] text-[gray]" />
      <span className="underline">{t('rules')}</span>
    </div>
  );
};

export default RuleItem;
